import { useReducerData } from 'store/hooks';

const useOptions = () => {
  const countryList = useReducerData('addProduct', 'countryList.data', []);
  const countryListOptions = countryList.map((c) => ({
    value: c.id,
    label: c.name,
    obj: c,
  }));
  return {
    countryListOptions,
  };
};

export default useOptions;
